/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction, Slice } from '@reduxjs/toolkit';
import { FUNDS_LIST_API } from 'services/constants';
import { FundsListResponse } from 'services/types';
import { isApiFetchingCompletedAction } from '../utils';

const isFundsListApiFullfilledAction =
  isApiFetchingCompletedAction(FUNDS_LIST_API);

export interface FundsState {
  selectedFund: string;
  fundsList: string[];
}

const initialState: FundsState = {
  selectedFund: '',
  fundsList: [],
};

export const fundsSlice: Slice<FundsState> = createSlice({
  name: 'fundsSlice',
  initialState,
  reducers: {
    updateSelectedFunds: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        selectedFund: action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      isFundsListApiFullfilledAction,
      (state, action: PayloadAction<FundsListResponse[]>) => {
        const { payload } = action;
        state.selectedFund = payload[0]?.name;
        state.fundsList = payload.map((funds) => funds.name);
      }
    );
  },
});

export const { updateSelectedFunds } = fundsSlice.actions;
